// extracted by extract-css-chunks-webpack-plugin
module.exports = {"local_embed":"LocalEmbed__local_embed--2C7xF","description":"LocalEmbed__description--1fD4z"};